export const ROLE_OPERATEUR_FORM_NAME = "roleOperateurId";
export const CRITERE_FACTURATION_FORM_NAME = "critereFacturationCode";
export const PARAMETRE_DECOMPTE_FORM_NAME = "parametreDecompteCode";
export const TYPE_PAIEMENT_FORM_NAME = "typePaimentCode";
export const NOMBRE_TRANSACTIONS_FORM_NAME = "nbrTransaction";
export const FRAIS_ACCES_ANNUEL_FORM_NAME = "abonnementBase";
export const DEBUT_VALIDITEE_PACKAGE_FORM_NAME = "debutValiditeCode";
export const RECONDUCTION_PACKAGE_FORM_NAME = "reconduction";
export const STATUS_PACKAGE_FORM_NAME = "statutCode";
export const TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME = "typeFraisServiceCode";
export const DESCRIPTION_FORM_NAME = "description";
export const FRAIS_TRANSACTION_FORM_NAME = "fraisService";
export const TRANSACTION_AUTORISEE_FORM_NAME = "typeTransactionAutoriseeCode";
